export const adjective = {
	singular: "pro",
	plural: "pros",
};

export const verb = {
	singular: "working",
};

export const job = {
	singular: "job",
	plural: "jobs",
};
